import { NewsType } from '@/pages/[categorias]/[...news]';
import { Dispatch, SetStateAction, createContext } from 'react';

const PageDataContext = createContext<{ pageData: NewsType['responseData']; setPageData: Dispatch<SetStateAction<NewsType['responseData']>> }>(null);

export default PageDataContext;
